import React from "react";

const Footer = () => {
  return (
    <footer>
      <i><p style={{color:"white"}}>Play, pause and resume watching, all without commercials or commitments.</p></i>
    </footer>
  );
};

export default Footer;
